module.exports = __webpack_public_path__ + "img/KSC00248.fcca8db5.jpg";